export default "dist/images/block-call-to-action-horizontal.9a3abd0.png";